export default __webpack_public_path__ + "static/media/ico_modal_close_pmib.c484493c.svg";